<template>
  <v-container id="private_policy">
    <v-card color="grey lighten-4" flat height="100%">
      <main-menu :menuOptions="menuOptions"></main-menu>

      <v-card flat color="transparent" class="justify-center">
        <v-row class="justify-center ma-3">
        </v-row>
        <v-row>
          <v-col>
            <v-card-text>
              <div :id="storeKey"></div>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
    <Footer></Footer>
  </v-container>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
// import List from "@editorjs/list";
import Table from "@editorjs/table";
import Checklist from "@editorjs/checklist";
import Code from "@editorjs/code";
import Delimiter from "@editorjs/delimiter";
import Embed from "@editorjs/embed";
import InlineCode from "@editorjs/inline-code";
import Link from "@editorjs/link";
import Marker from "@editorjs/marker";
import NestedList from "@editorjs/nested-list";
import Raw from "@editorjs/raw";
// import SimpleImage from "@editorjs/simple-image";
import Underline from "@editorjs/underline";
import Warning from "@editorjs/warning";
import Quote from "@editorjs/quote";
import Paragraph from "editorjs-paragraph-with-alignment";
import AlignmentBlockTune from "editorjs-text-alignment-blocktune";
import ImageTool from '@editorjs/image';

import { GetWebsiteBasicContent, GetWebsiteBasicContentVer } from "@/api/publicServices";
import { getLS, setLS } from "@/api/common";

export default {
  metaInfo: {
    title: "私隱政策",
    titleTemplate: "%s | 青蛙集運",
  },
  props: ["nextUrl"],
  mounted() {
  },
  created() {
    this.contentArea = new EditorJS({
      holder: this.storeKey,
      readOnly: true,
          onReady: ()=> {
            this.getInfo();
          },
      tools: {
        header: {
          class: Header,
          tunes: ['textAlignTune'],
        },
        // list: List,
        list: NestedList,
        table: Table,
        paragraph:  {
          class: Paragraph,
          inlineToolbar: true,
        },
        checklist: Checklist,
        code: Code,
        delimiter: Delimiter,
        embed: Embed,
        "inline-code": InlineCode,
        link: Link,
        marker: Marker,
        "nested-list": NestedList,
        raw: Raw,
        image: ImageTool,
        underline: Underline,
        quote: Quote,
        warning: Warning,
        textAlignTune: {
          class: AlignmentBlockTune,
          config: {
              default: "left",
              blocks: {
                  header: 'center',
              }
          },
        }
      }
    });

  },
  data() {
    return {
      menuOptions: ["self-pick-spot", "pricing", "news", "faq", "login", "register", "locale"],
      contentArea: null,
      storeKey: "PRIVACY_POLICY"
    };
  },
  methods: {
      async getVer() {
        const response = await GetWebsiteBasicContentVer({});
        return response.data;
      },
      async getInfo() {

        try {

          let version = await this.getVer();

          let currentVersion = localStorage.getItem('version');
          let content = "";
          if (version == currentVersion) {
            let content = getLS(this.storeKey);
            if (content != null) {

              this.contentArea.blocks.clear();
              this.contentArea.blocks.render(JSON.parse(content.Description));
              return;
            }
          }

          const response = await GetWebsiteBasicContent({});
          let profiles = response.data;

          for (let index in profiles) {
            setLS(profiles[index].ContentType, profiles[index], 6000);
          }

          localStorage.setItem("version", version+"");


          content = getLS(this.storeKey)
          this.contentArea.blocks.clear();
          this.contentArea.blocks.render(JSON.parse(content.Description));

        } catch (error) {
          console.log(error);
        }
      }
  },
};
</script>
<style scoped>
#news-editor >>> .ce-block__content code.inline-code {
  color: #8CC63F;
  font-size: 100%;
  background-color: transparent;
}
</style>>